interface StageOutOfScopeMessageProps {
  stageLabel: string;
}

const StageOutOfScopeMessage = ({ stageLabel }: StageOutOfScopeMessageProps) => {
  return (
    <div className="ic-stage-not-set-body">
      <div className="ic-stage-not-set-card" role="status">
        Out of scope — {stageLabel} optional.
      </div>
    </div>
  );
};

export default StageOutOfScopeMessage;
